import { render, staticRenderFns } from "./ButtonMore.vue?vue&type=template&id=59679a3b&scoped=true"
import script from "./ButtonMore.vue?vue&type=script&lang=js"
export * from "./ButtonMore.vue?vue&type=script&lang=js"
import style0 from "./ButtonMore.vue?vue&type=style&index=0&id=59679a3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59679a3b",
  null
  
)

export default component.exports